/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerDetailDto } from '../../models/lexplus-benutzer-detail-dto';
import { LexplusUpdateBenutzerDto } from '../../models/lexplus-update-benutzer-dto';

export interface BenutzerverwaltungControllerUpdateV1$Params {
  id: string;
      body: LexplusUpdateBenutzerDto
}

export function benutzerverwaltungControllerUpdateV1(http: HttpClient, rootUrl: string, params: BenutzerverwaltungControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerDetailDto>;
    })
  );
}

benutzerverwaltungControllerUpdateV1.PATH = '/v1/benutzerverwaltung/{id}';
